module.exports = __webpack_public_path__ + "02_bob_brown.345f329f.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/02_bob_brown.png
// module id = ExZ+
// module chunks = 0